<template>
  <benefit-dialog :visible ="visible" :type="3">
    <h2 class="benefit-title" slot="title">您已激活过该福利</h2>
    <div slot="body" class="benefit-vip-box has-activated" >
      <div  class="benefit-vip-card " :class="benefitType" >
        <span class="amount" v-if="benefitType === 'voucher'">{{amount}}元代金券</span>
      </div>
    </div>
    <benefit-button slot="footer" @click.native="handleClose">我知道了</benefit-button>
  </benefit-dialog>
</template>

<script>
import BenefitButton from '@/components/benefit/button.vue'
import BenefitDialog from '@/components/benefit/dialog.vue'
import eventHub from './eventHub'
export default {
  components: {
    BenefitButton,
    BenefitDialog
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      benefitType: '',
      amount: 0
    }
  },
  methods: {
    handleClose () {
      eventHub.$emit('update:visible', 3, false)
    }
  },
  created () {
    eventHub.$on('update:props', (type, { benefitType, amount }) => {
      if (type) {
        this.benefitType = benefitType
        this.amount = amount
      }
    })
  },
  beforeDestroy () {
    eventHub.$off('update:props')
  }
}
</script>

<style lang="scss">
.benefit-vip-box.has-activated {
  display: flex;
  justify-content: center;
  .benefit-vip-card {
    background-size: contain;
    position: relative;
    .amount {
      position: absolute;
      bottom: 8.333px; /*no*/
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px; /*no*/
      color: #ba7f2b;
      text-align: center;
    }
    &.voucher {
      width: 245px; /*no*/
      height: 84px; /*no*/
      margin: 45px auto 66px auto; /* no*/
      background-image: url('~assets/benefit/voucher-s@3x.png');
    }
    &.vip {
      width: 203px; /*no*/
      height: 104px; /*no*/
      margin: 36px auto 55px auto; /* no*/
      background-image: url('~assets/benefit/vip-s@3x.png');
    }
  }
}
</style>
